// src/pages/Pipeline/SiteVisitComplete.jsx
import React, { useState } from "react";
import { Box, Paper, TextField, Typography, Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../utils/api";

export default function SiteVisitComplete() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [visitId, setVisitId] = useState("");

  async function submit(e) {
    e.preventDefault();
    try {
      await api.post("/leads/site-visit/complete", {
        lead_id: id,
        visit_id: visitId
      });
      alert("Visit marked completed");
      navigate(`/leads/${id}`);
    } catch (err) {
      console.error(err);
      alert("Error completing visit");
    }
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5">Complete Site Visit</Typography>
      <Paper sx={{ p: 3, mt: 2 }}>
        <form onSubmit={submit}>
          <TextField
            label="Visit ID"
            fullWidth
            required
            sx={{ mb: 2 }}
            value={visitId}
            onChange={(e) => setVisitId(e.target.value)}
          />
          <Button type="submit" variant="contained">Mark Completed</Button>
          <Button variant="outlined" sx={{ ml: 2 }} onClick={() => navigate(-1)}>Back</Button>
        </form>
      </Paper>
    </Box>
  );
}
